export default __webpack_public_path__ + "assets/59c7a4880f260d3869dac7bbb6f3506b.svg";